import React from 'react';
import Icon from 'components/icon/icon'

const LoadMore = props => {
    const {
        isLoading,
        canLoadMore,
        onClick,
        type
    } = props

    if (!canLoadMore) {
        return null
    }

    return (
        <div className="load-more">
            <button
                onClick={onClick}
            >
                <Icon name={`fe-refresh-cw ${isLoading ? 'fa-spin' : ''}`} />
                <span>
                    { isLoading ? 'Loading...' : `Load more ${ type }`}
                </span>
            </button>
        </div>
    )
};

export default LoadMore;
